import Emission from "./Emission";

class EmissionPerYear {
  constructor(objectYears) {
    this.years = {};
    for (const [year, emissions] of Object.entries(objectYears)) {
      this.years[year] = emissions.map((e) => new Emission(e));
    }
  }

  getAvailableYears() {
    return Object.keys(this.years);
  }

  getEmissionsByYear(year) {
    return this.years[year] || [];
  }
}

export default EmissionPerYear;
